import { selectAuthenticationStatus, setAuthenticationStatus, setAuthenticationUser } from "./slices";
import { STATUSES } from "../../util/constants";
import { isUnauthenticated } from "../../util/functions";
import { fetchCurrentSession, redirectToLogIn } from "../../util/login";
import { authorizationApi } from "./api";
import { signOut } from "aws-amplify/auth";

export const buildLoginQuery = {
  queryFn: async (parameters = {}, { dispatch, getState }) => {
    const { redirectPath, doNotRedirect, force } = parameters;
    const status = selectAuthenticationStatus(getState())
    
    if(status === STATUSES.COGNITO_FAILURE && !force) {
      return {
        error: {
          status: STATUSES.ERROR
        }
      }
    }
    const shouldRedirect = !doNotRedirect;

    try {
      const payload = await fetchCurrentSession();
      if (payload?.osuid) {
        dispatch(setAuthenticationUser(payload));
        return {
          data: payload,
        };
      } else if(shouldRedirect) {
        redirectToLogIn(redirectPath);
      }
    } catch (error) {
      if (isUnauthenticated(error) && shouldRedirect) {
          redirectToLogIn(redirectPath);
      } 
      return {
        data: {
          status: STATUSES.IDLE
        }
      }
    }
    return {}; // Must return object or causes exception that bubbles up to withErrorBoundary
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      authorizationApi.endpoints.getAffiliations.matchPending,
      (state) => {
        state.status = STATUSES.LOADING;
      }
    );
    builder.addMatcher(authorizationApi.endpoints.getAffiliations.matchFulfilled,
      (state) => {
        state.status = STATUSES.SUCCESS;
      }
    );
    builder.addMatcher(authorizationApi.endpoints.getAffiliations.matchRejected,
      (state) => {
        state.status = STATUSES.ERROR;
      }
    );
  }
};

export const buildLogoutQuery = {
  queryFn: async (parameters, { dispatch }) => {
    dispatch(setAuthenticationStatus(STATUSES.LOADING))
    await signOut({
      global: true
    });
    dispatch(setAuthenticationStatus(STATUSES.CLEARED))
    return {
        data: {
            status: STATUSES.CLEARED
        }
    }
  },
};
